import { urlConst } from '../consts';
import { apiService } from './api.service';

export const requestService = {
    getCategories,
    getRequests,
    addRequest,
    updateData,
    addReqUser,
    rmReqUser,
    updateReqUser,
    addComment,
    readComment,
    addReqFile,
    rmReqFile,
    bindReqFileToUser,
    saveExtData,
    addReqFileLink,
    moveRequest,
    addReqFileThumbnail,
};

function getCategories() {
    return apiService.get(urlConst.API_GET_CATEGORIES);
}

function getRequests(eventName = '') {
    return apiService.get(`${urlConst.API_GET_REQUESTS}?event=${eventName}`).then(processRequestsResponse);
}

function addRequest(requestData) {
    return apiService.post(urlConst.API_ADD_REQUEST, JSON.stringify(requestData)).then(processRequestsResponse);
}

function updateData(fieldData) {
    return apiService.put(urlConst.API_UPDATE_REQUEST_FIELD, JSON.stringify(fieldData)).then(processRequestsResponse);
}

function addReqUser(userData) {
    return apiService.post(urlConst.API_ADD_REQUEST_USER, JSON.stringify(userData)).then(processRequestsResponse);
}

function rmReqUser(userData) {
    return apiService.delete(urlConst.API_DEL_REQUEST_USER, JSON.stringify(userData)).then(processRequestsResponse);
}

function updateReqUser(userData) {
    return apiService.put(urlConst.API_UPDATE_REQUEST_USER, JSON.stringify(userData)).then(processRequestsResponse);
}

function addComment(commentData) {
    return apiService.post(urlConst.API_ADD_REQUEST_COMMENT, JSON.stringify(commentData)).then(processRequestsResponse);
}

function readComment(commentId) {
    return apiService
        .post(urlConst.API_READ_REQUEST_COMMENT.replace('{commentId}', commentId))
        .then(processRequestsResponse);
}

function addReqFile(fileData, onProgress) {
    if (!fileData.userId) {
        delete fileData.userId;
    }
    return apiService.postMultiData(urlConst.API_ADD_REQUEST_FILE, fileData, onProgress).then(processRequestsResponse);
}

function rmReqFile(fileData) {
    return apiService.delete(urlConst.API_DEL_REQUEST_FILE, JSON.stringify(fileData)).then(processRequestsResponse);
}

function bindReqFileToUser(data) {
    return apiService.post(urlConst.API_BIND_REQUEST_FILE, JSON.stringify(data)).then(processRequestsResponse);
}

function saveExtData(extData) {
    return apiService.post(urlConst.API_SAVE_EXT_DATA, JSON.stringify(extData)).then(processRequestsResponse);
}

function addReqFileLink(fileData) {
    return apiService.post(urlConst.API_ADD_REQUEST_FILE_LINK, JSON.stringify(fileData)).then(processRequestsResponse);
}

function addReqFileThumbnail(imageData) {
    return apiService
        .post(urlConst.API_ADD_REQUEST_FILE_THUMBNAIL, JSON.stringify(imageData))
        .then(processRequestsResponse);
}

/*
TODO: особый случай, временная функция, которую потом нужно удалить
 */
function moveRequest(request) {
    return apiService.get(`${urlConst.API_MOVE_REQUEST}?request=${request.id}`);
}

async function processRequestsResponse(response) {
    if (response) {
        processRequests(response.author);
        processRequests(response.participant);
    }
    return response;
}

function processRequests(requests) {
    if (!requests || requests.length === 0) return;
    requests.forEach((request) => {
        //console.log('process request', request);
        request.title = getTitleForRequest(request);
    });
}

function getTitleForRequest(request) {
    if (!request || !request.fields) return '';
    const recipient = getOneOf([10], request.fields);
    const fandom = getOneOf([18, 19, 20, 21], request.fields);
    const name = getOneOf([12, 13], request.fields);
    return [recipient, name ? `"${name}"` : name, fandom].filter((v) => !!v).join(' - ');
}

function getOneOf(fieldIds, fields) {
    if (!fieldIds || fieldIds.length === 0 || !fields) return '';
    const foundFieldId = Object.keys(fields).find((fieldId) => fieldIds.includes(+fieldId));
    return foundFieldId ? fields[foundFieldId].value : '';
}
